import useConfig from '@sdk/config/useConfig';
import useAuth from '@sdk/authentication/useAuth';
import { isFeatureEnabled } from '@sdk/utils/isFeatureEnabled';

export const useAutomatedBreaksPremiumPayFeatureFlagEnabled = () => {
  const {
    FEATURE_FLAGS: { AUTOMATED_BREAKS, AUTOMATED_BREAKS_PREMIUM_PAY },
  } = useConfig();

  const { currentUser } = useAuth();

  return (
    isFeatureEnabled(AUTOMATED_BREAKS, currentUser.org.id) &&
    isFeatureEnabled(AUTOMATED_BREAKS_PREMIUM_PAY, currentUser.org.id)
  );
};
